import * as React from 'react'
import { Tooltip } from '../overlay/tooltip'

export interface FieldLabelHelpProps {
	label: string
	labelHelp?: React.ReactNode
	labelHelpTitle?: string
}

function HelpIcon() {
	return (
		<svg viewBox="0 0 20 20" aria-hidden="true" className="h-3.5 w-3.5" fill="none">
			<circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.6" />
			<path d="M7.9 7.7a2.2 2.2 0 0 1 4.2.9c0 1.6-1.6 2-1.9 3.1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
			<circle cx="10" cy="14.5" r=".8" fill="currentColor" />
		</svg>
	)
}

export function FieldLabelContent({ label, labelHelp, labelHelpTitle }: FieldLabelHelpProps) {
	if (!labelHelp) return <>{label}</>

	return (
		<span className="inline-flex items-center gap-1.5">
			<span>{label}</span>
			<Tooltip title={labelHelpTitle ?? label} content={labelHelp} side="top">
				<span
					role="button"
					tabIndex={0}
					aria-label={`Help for ${label}`}
					className="inline-flex h-5 w-5 items-center justify-center rounded-full text-info transition-colors hover:bg-info/10 hover:text-info focus:outline-none focus:ring-2 focus:ring-gold/40"
				>
					<HelpIcon />
				</span>
			</Tooltip>
		</span>
	)
}
